import * as Yup from "yup";

const MasterClassValidationSchema = Yup.object({
  title: Yup.string()
    .required("Title is required")
    .max(255, "Title must be less than 255 characters"),
  facultyName: Yup.string()
    .required("Faculty Name is required")
    .max(255, "Faculty Name must be less than 255 characters"),
  facultyImage: Yup.string()
    .url("Enter a valid URL")
    .max(1000, "Faculty Image URL must be less than 1000 characters"),
  subject: Yup.string().max(255, "Subject must be less than 255 characters"),
  experienceYears: Yup.number()
    .integer("Experience Years must be an integer")
    .min(0, "Experience Years must be 0 or greater")
    .nullable(),
  scheduledDate: Yup.date()
    .required("Scheduled Date is required")
    .typeError("Please enter a valid date"),
  scheduledTime: Yup.string().required("Scheduled Time is required"),
  messageForPurchased: Yup.string(),
  messageForNotPurchased: Yup.string(),
  tips: Yup.array().of(Yup.string()),
  imageUrl: Yup.string()
    .url("Enter a valid URL")
    .max(1000, "Image URL must be less than 1000 characters"),
  buttonText: Yup.string().max(255, "Button Text must be less than 255 characters"),
  bookId: Yup.number().nullable(),
  universityId: Yup.number().nullable(),
  courseId: Yup.number().nullable(),
  semesterId: Yup.number().nullable(),
  regulationYearId: Yup.number().nullable(),
  active: Yup.boolean().default(true),
});

export default MasterClassValidationSchema;

